<article class="search-results-not-found">
  <div class="search-results-not-found__message">
    Your search for <strong>"{{ searchTerms }}"</strong> didn't match any records. Please try another search term.
  </div>
  <div class="search-results-not-found__thumb">
    <ftr-illustration [illustration]="illustration.SearchResultsNotFound"></ftr-illustration>
  </div>
</article>
